<template>
  <div>
    <h1>My Account</h1>
    <div class="row">
      <div class="col-md-6">
        <div class="panel panel-default">
          <div class="panel-body">
            <h2 class="mt-0"><strong>Personal Information</strong></h2>
            <form action="">
              <div :class="['form-group', { 'has-error': errors.firstName }]">
                <label for="first-name">First Name:</label>
                <input
                  :disabled="true"
                  id="first-name"
                  :value="user.firstName"
                  type="text"
                  class="form-control"
                />
                <span v-if="errors.firstName" class="help-block">{{ errors.firstName }}</span>
              </div>
              <div :class="['form-group', { 'has-error': errors.lastName }]">
                <label for="last-name">Last Name:</label>
                <input
                  :disabled="true"
                  id="last-name"
                  :value="user.lastName"
                  type="text"
                  class="form-control"
                />
                <span v-if="errors.lastName" class="help-block">{{ errors.lastName }}</span>
              </div>
              <div :class="['form-group', { 'has-error': errors.email }]">
                <label for="email">Email</label>
                <input v-model="user.email" id="email" type="email" class="form-control" />
                <span v-if="errors.email" class="help-block">{{ errors.email }}</span>
              </div>

              <p v-show="showPersonalSuccess" class="bg-success text-center p-10">
                {{ personalSuccess }}
              </p>
              <div class="row">
                <div class="col-md-4 col-sm-6 col-12">
                  <button @click.prevent="updatePersonalInfo" class="btn btn-success mt-10">
                    Update Personal Information
                  </button>
                </div>
                <div class="col-md-4 col-lg-offset-4 col-sm-6 col-12 text-center">
                  <a
                    href="https://www.capsim.com/terms?tab-3"
                    target="_blank"
                    class="terms-conditions"
                    >Terms & Conditions
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="panel panel-default">
          <div class="panel-body">
            <h2 class="mt-0"><strong>Account Information</strong></h2>
            <form>
              <div :class="['form-group', { 'has-error': errors.username }]">
                <label for="username">Username:</label>
                <input
                  id="username"
                  :disabled="true"
                  :value="user.username"
                  type="text"
                  class="form-control"
                />
                <span v-if="errors.username" class="help-block">{{ errors.username }}</span>
              </div>

              <a @click.prevent="showChangePassword = !showChangePassword" href="#"
                >Change Password</a
              >
              <template v-if="showChangePassword">
                <div>
                  <hr />

                  <div :class="['form-group', { 'has-error': errors.currentPassword }]">
                    <label for="current-password">Current Password:</label>
                    <input
                      id="current-password"
                      v-model="user.currentPassword"
                      type="password"
                      class="form-control"
                    />
                    <span v-if="errors.currentPassword" class="help-block">{{
                      errors.currentPassword
                    }}</span>
                  </div>

                  <div :class="['form-group', { 'has-error': errors.password }]">
                    <label for="new-password">New Password:</label>
                    <input
                      v-model="user.password"
                      id="new-password"
                      type="password"
                      class="form-control"
                    />
                    <span v-if="errors.password" class="help-block">{{ errors.password }}</span>
                  </div>

                  <div :class="['form-group', { 'has-error': errors.passwordConfirmation }]">
                    <label for="password-confirmation">New Password Confirmation:</label>
                    <input
                      v-model="user.passwordConfirmation"
                      id="password-confirmation"
                      type="password"
                      class="form-control"
                    />
                    <span v-if="errors.passwordConfirmation" class="help-block">{{
                      errors.passwordConfirmation
                    }}</span>
                  </div>

                  <p v-show="showAccountSuccess" class="bg-success text-center p-10">
                    {{ accountSuccess }}
                  </p>

                  <button class="btn btn-success mt-10" @click.prevent="updatePassword">
                    Update Account Information
                  </button>
                </div>
              </template>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MyAccount',

    data() {
      return {
        user: {
          firstName: '',
          lastName: '',
          email: '',
          username: '',
          currentPassword: '',
          password: '',
          passwordConfirmation: '',
        },
        showChangePassword: false,
        showAccountSuccess: false,
        showPersonalSuccess: false,
        errors: {},
        accountSuccess: 'Password has been successfully updated.',
        personalSuccess: 'Email has been successfully updated.',
      };
    },

    created() {
      this.user = { ...this.user, ...this.$store.state.user };
    },

    methods: {
      clearUserFields() {
        this.user.currentPassword = '';
        this.user.password = '';
        this.user.passwordConfirmation = '';
      },

      updatePassword() {
        this.showAccountSuccess = false;
        this.errors = this.validateAccountInfo();

        if (Object.keys(this.errors).length) return;

        let payload = {
          currentPassword: this.user.currentPassword,
          password: this.user.password,
        };

        this.errors = {};

        $.ajax({
          url: '/capsiminbox/authoring-platform/update-user',
          method: 'post',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(payload),
        })
          .done(({ success, messages }) => {
            if (success) {
              this.showAccountSuccess = true;
              this.clearUserFields();
            } else {
              this.errors = Object.keys(messages).reduce((acc, key) => {
                acc[key] = messages[key];
                return acc;
              }, {});
            }
          })
          .catch((err) => (this.showServerError = true));
      },

      updatePersonalInfo() {
        this.showPersonalSuccess = false;
        this.errors = this.validatePersonalInfo();

        if (Object.keys(this.errors).length) return;

        let payload = {
          email: this.user.email,
        };

        $.ajax({
          url: '/capsiminbox/authoring-platform/update-user',
          method: 'post',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(payload),
        })
          .done(({ success }) => {
            if (success) this.showPersonalSuccess = true;
            else {
            }
          })
          .catch((err) => (this.showServerError = true));
      },

      validateAccountInfo() {
        let errors = {};

        if (this.user.username.length < 6)
          errors['username'] = 'Username should have a minimum of 6 characters';
        if (this.user.currentPassword.length < 6)
          errors['currentPassword'] = 'Please enter a valid current password';
        if (this.user.password < 6)
          errors['password'] = 'Password should have a minimum of 6 characters';
        if (this.user.passwordConfirmation !== this.user.password)
          errors['passwordConfirmation'] = 'Password confirmation should match the password';

        return errors;
      },

      validatePersonalInfo() {
        let errors = {};

        if (!/\S+@\S+\.\S+/.test(this.user.email)) errors['email'] = 'Please enter a valid email';
        if (this.user.firstName.length < 2) errors['firstName'] = 'Please enter a valid first name';
        if (this.user.lastName.length < 2) errors['lastName'] = 'Please enter a valid last name';

        return errors;
      },
    },
  };
</script>
<style lang="scss" scoped>
  a.terms-conditions {
    font-size: 18px;
    top: 1.5rem;
    position: relative;
  }
</style>
